import { createContext, useContext, useMemo, useReducer } from "react";
import { newKey } from "@/lib/intakeApi";

const initialContact = {
  full_name: "", email: "", organization: "", country: "", organization_type: "",
  callback_requested: false, phone: "", callback_time: "", callback_timezone: "", consent: false, website: "",
};
const initialState = { needs: [], details: "", submitted: null, answers: {}, contact: initialContact, lead: null };

function reducer(state, action) {
  switch (action.type) {
    case "toggleNeed": {
      const has = state.needs.includes(action.id);
      return { ...state, needs: has ? state.needs.filter((n) => n !== action.id) : [...state.needs, action.id] };
    }
    case "selectNeed":
      return state.needs.includes(action.id) ? state : { ...state, needs: [...state.needs, action.id] };
    case "setDetails":
      return { ...state, details: action.value };
    case "submit":
      return { ...state, submitted: { needs: [...state.needs], details: state.details.trim() }, lead: { id: null, key: action.key } };
    case "setContact":
      return { ...state, contact: { ...state.contact, ...action.patch } };
    case "leadSaved":
      return { ...state, lead: { ...state.lead, id: action.id, token: action.token, callback: state.contact.callback_requested } };
    case "leadSent":
      return { ...state, lead: { ...state.lead, sent: true } };
    case "setAnswer":
      return { ...state, answers: { ...state.answers, [action.id]: action.value } };
    case "reset":
      return initialState;
    default:
      return state;
  }
}

const DiagnosticContext = createContext(null);

// Draft lives in memory; only the contact step sends data to the API.
export function DiagnosticProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const api = useMemo(
    () => ({
      state,
      toggleNeed: (id) => dispatch({ type: "toggleNeed", id }),
      selectNeed: (id) => dispatch({ type: "selectNeed", id }),
      setDetails: (value) => dispatch({ type: "setDetails", value }),
      submit: () => dispatch({ type: "submit", key: newKey() }),
      setContact: (patch) => dispatch({ type: "setContact", patch }),
      leadSaved: (id, token) => dispatch({ type: "leadSaved", id, token }),
      leadSent: () => dispatch({ type: "leadSent" }),
      setAnswer: (id, value) => dispatch({ type: "setAnswer", id, value }),
      reset: () => dispatch({ type: "reset" }),
      canSubmit: state.needs.length > 0 || state.details.trim().length > 0,
    }),
    [state]
  );
  return <DiagnosticContext.Provider value={api}>{children}</DiagnosticContext.Provider>;
}

export const useDiagnostic = () => useContext(DiagnosticContext);
